import { Component, OnInit, ElementRef } from '@angular/core';
import { Globals } from "app/globals";
declare const $: any;
import { Location } from '@angular/common';
import { EnvironmentEnum } from 'app/core/enums/environment-enum';


declare interface RouteInfo {
    path: string;
    menuTitle: string;
    headerTitle: string;
    icon: string;
    class: string;
}

export const ADMIN_ROUTES: any[] = [
    /*
    { path: 'dashboard',menuTitle: 'Dashboard',  icon: 'pe-7s-graph', class: '' },
    { path: 'user',menuTitle: 'User Profile',  icon:'pe-7s-user', class: '' },
    { path: 'table',menuTitle: 'Table List',  icon:'pe-7s-note2', class: '' },
    { path: 'typography',menuTitle: 'Typography',  icon:'pe-7s-news-paper', class: '' },
    { path: 'icons',menuTitle: 'Icons',  icon:'pe-7s-science', class: '' },
    { path: 'maps',menuTitle: 'Maps',  icon:'pe-7s-map-marker', class: '' },
    { path: 'notifications',menuTitle: 'Notifications',  icon:'pe-7s-bell', class: '' },
    { path: 'upgrade',menuTitle: 'Upgrade to PRO', icon: 'pe-7s-rocket', class: 'active-pro' },
    { path: 'icons',menuTitle: 'Home', icon: '', class: '' },
    */
    //{ path: 'home',menuTitle: 'Home', icon: 'pe-7s-home', class: '' },
    //{ path: 'niches', title: 'Niches', icon: 'pe-7s-notebook', class: '' },
    [
        { path: 'admin_dashboard', menuTitle: 'Dashboard', headerTitle: 'Dashboard', icon: 'pe-7s-note2', class: 'titleMenu' }
        //{ path: 'eli', menuTitle: 'ELI', headerTitle: 'ELI Assessments', icon: 'pe-7s-star', class: 'submenu' },
        //{ path: '360', menuTitle: '360', headerTitle: '360 Assessments', icon: 'pe-7s-rocket', class: 'submenu' }
    ],
    [
        { path: 'eli', menuTitle: 'Assessments', headerTitle:'ELI Assessments', icon: 'pe-7s-note2', class: 'titleMenu' }
        //{ path: 'eli', menuTitle: 'ELI', headerTitle: 'ELI Assessments', icon: 'pe-7s-star', class: 'submenu' },
        //{ path: '360', menuTitle: '360', headerTitle: '360 Assessments', icon: 'pe-7s-rocket', class: 'submenu' }
    ],
    [
        { path: 'assessments_sections', menuTitle: 'ELI Sections', headerTitle: 'ELI Sections', icon: 'pe-7s-users', class: 'titleMenu' },
    ],
    //[
    //    { path: 'notdefinied', menuTitle: 'ELI', headerTitle: '', icon: 'pe-7s-news-paper', class: '' },
    //    { path: 'regular', menuTitle: 'Regular', headerTitle: 'Regular Section', icon: 'pe-7s-flag', class: 'submenu' },
    //    { path: 'satisfaction', menuTitle: 'Satisfaction', headerTitle: 'Satisfaction Section', icon: 'pe-7s-smile', class: 'submenu' },
    //    { path: 'survey', menuTitle: 'Survey', headerTitle: 'Survey Section', icon: 'pe-7s-global', class: 'submenu' },
    //],
    [
        { path: 'sections_360', menuTitle: '360 Sections', headerTitle: '360 Sections', icon: 'pe-7s-world', class: 'titleMenu' }
        //{ path: 'eli', menuTitle: 'ELI', headerTitle: 'ELI Assessments', icon: 'pe-7s-star', class: 'submenu' },
        //{ path: '360', menuTitle: '360', headerTitle: '360 Assessments', icon: 'pe-7s-rocket', class: 'submenu' }
    ],
    //[
    //    { path: 'notdefinied', menuTitle: '360 Questions', headerTitle: '', icon: 'pe-7s-world', class: '' },
    //    { path: 'section1', menuTitle: 'Section 1', headerTitle: 'Section 1 Questions', icon: 'pe-7s-ribbon', class: 'submenu' },
    //    { path: 'section2', menuTitle: 'Section 2', headerTitle: 'Section 2 Questions', icon: 'pe-7s-note2', class: 'submenu' },
    //],
    [
        { path: 'emailtemplates', menuTitle: 'Email Templates', headerTitle: 'Email Templates', icon: 'pe-7s-mail-open-file', class: 'titleMenu' }
        //{ path: 'notdefinied', menuTitle: 'Templates', headerTitle: '', icon: 'pe-7s-mail-open-file', class: '' },
        //{ path: 'emailtemplates', menuTitle: 'Email', headerTitle: 'Email Templates', icon: 'pe-7s-mail', class: 'submenu' },
    ],
    [

        { path: 'rater_types', menuTitle: 'Relationships', headerTitle: 'Relationships', icon: 'pe-7s-id', class: 'titleMenu' }
    ],
    [

        { path: 'announcements', menuTitle: 'Announcements', headerTitle: 'Announcements', icon: 'pe-7s-display2', class: 'titleMenu' }
    ],
    [

        { path: 'users', menuTitle: 'Users', headerTitle: 'Users', icon: 'pe-7s-users', class: 'titleMenu' }
    ],
    [
        { path: 'duplicate_users', menuTitle: 'Duplicate Users', headerTitle: 'Duplicate Users', icon: 'pe-7s-users', class: 'titleMenu' }
    ],
    [
        { path: 'assessments_mod_i', menuTitle: 'MOD I Assessments', headerTitle: 'MOD I Assessments', icon: 'pe-7s-note2', class: '' },
    ],
    [
        { path: 'assessments_mod_lll', menuTitle: 'MOD III Assessments', headerTitle: 'MOD III Assessments', icon: 'pe-7s-note2', class: '' },
    ],
    [

        { path: 'error_log', menuTitle: 'Error Log', headerTitle: 'Error Log', icon: 'pe-7s-display1', class: '' }
    ]
    //[
    //    { path: 'notdefinied', menuTitle: 'Business Inteligence', headerTitle: '', icon: 'pe-7s-medal', class: '' },//bordertop
    //    { path: 'bidashboard', menuTitle: 'Dashboard', headerTitle: 'Dashboard', icon: 'pe-7s-display1', class: 'submenu' },
    //    { path: 'datavisualizer', menuTitle: 'Data Visualizer', headerTitle: 'Data Visualizer', icon: 'pe-7s-exapnd2', class: 'submenu' },
    //],
    //[
        
    //    { path: 'business_inteligence', menuTitle: 'Business Inteligence', headerTitle: 'Business Inteligence', icon: 'pe-7s-medal', class: 'titleMenu' }
    //]

    //{ path: 'rater',menuTitle: 'Rater', icon: 'pe-7s-id', class: 'submenu' },
    //{ path: 'Trend',menuTitle: 'Trend Analysis', icon: 'pe-7s-mail', class: 'submenu' },
    //{ path: 'help',menuTitle: 'Help', icon: 'pe-7s-help1', class: 'borderTop' },
];

export const COACHES_ROUTES: any[] = [
    
    //[
    //    { path: 'notdefinied', menuTitle: 'Assessments', headerTitle: '', icon: 'pe-7s-note2', class: '' },
    //    { path: 'unassigned', menuTitle: 'Unassigned', headerTitle: 'Unassigned Assessments', icon: 'pe-7s-delete-user', class: 'submenu' },
    //    //{ path: 'purchasehistory',menuTitle: 'Purchase history', icon: 'pe-7s-piggy', class: 'submenu' },
    //    { path: 'assigned', menuTitle: 'Assigned', headerTitle: 'Assigned Assessments', icon: 'pe-7s-back-2', class: 'submenu' },
    //    { path: 'ccompleted', menuTitle: 'Completed', headerTitle: 'Completed Assessments', icon: 'pe-7s-check', class: 'submenu' }
    //],
    [
        { path: 'coach_home', menuTitle: 'Home', headerTitle: 'Home', icon: 'pe-7s-home', class: '' },
    ],
    [
        { path: 'clients', menuTitle: 'Manage Clients', headerTitle: 'Manage clients', icon: 'pe-7s-users', class: '' },
    ],
    [
        { path: 'coach_assessments', menuTitle: 'Manage Assessments', headerTitle: 'Manage Assessments', icon: 'pe-7s-note2', class: '' },
    ],
    [
        { path: 'cemails', menuTitle: 'Email Templates', headerTitle: 'Email Templates', icon: 'pe-7s-mail-open-file', class: 'titleMenu' }
        //{ path: 'notdefinied', menuTitle: 'Email Templates', headerTitle: '', icon: 'pe-7s-mail-open-file', class: '' },
        ////{ path: 'predefined', menuTitle: 'Predefined', headerTitle: 'Predefined Templates', icon: 'pe-7s-cash', class: 'submenu' },
        ////{ path: 'custom', menuTitle: 'Custom', headerTitle: 'Custom Templates', icon: 'pe-7s-cash', class: 'submenu' }, 
        //{ path: 'cemails', menuTitle: 'Email', headerTitle: 'Email', icon: 'pe-7s-cash', class: 'submenu' }, 
    ],
    //[
    //    { path: 'tabs', menuTitle: 'Tabs', headerTitle: 'Tabs', icon: 'pe-7s-mail-open-file', class: 'titleMenu' }
    //] 
    //,
    //[
    //    { path: 'c_rater_types', menuTitle: 'Relationships', headerTitle: 'Relationships', icon: 'pe-7s-id', class: 'titleMenu' }
    //]
    //[
    //    { path: 'profile', menuTitle: 'Profile', headerTitle: 'Profile', icon: 'pe-7s-user', class: '' },
    //],
    //[
    //    { path: 'notdefinied', menuTitle: 'Business Inteligence', headerTitle: '', icon: 'pe-7s-medal', class: '' },
    //    { path: 'coachDashboard', menuTitle: 'Dashboard', headerTitle: 'Dashboard', icon: 'pe-7s-display1', class: 'submenu' }
    //]
    //{ path: 'tags',menuTitle: 'Tags', icon: 'pe-7s-id', class: '' },
    //{ path: 'help',menuTitle: 'Help', icon: 'pe-7s-help1', class: 'help' },
];

export const CLIENTS_ROUTES: any[] = [
    // [
    //     { path: 'energy_leadership', menuTitle: 'Energy Leadership', headerTitle: 'Energy Leadership', icon: 'pe-7s-gleam', class: '' }
        
    // ],
    [
        { path: 'client_assessments', menuTitle: 'Assessments', headerTitle: 'Assessments', icon: 'pe-7s-note2', class: '' },
        //{ path: 'notdefinied', menuTitle: 'Assessments', headerTitle: '', icon: 'pe-7s-note2', class: '' },
        //{ path: 'reports',menuTitle: 'Reports', icon: 'pe-7s-photo-gallery', class: '' },
        //{ path: 'pending', menuTitle: 'Pending', headerTitle: 'Pending Assessments', icon: 'pe-7s-photo-gallery', class: 'submenu' },
        //{ path: 'completed', menuTitle: 'Completed', headerTitle: 'Completed Assessments', icon: 'pe-7s-check', class: 'submenu' }
    ],
    [
        { path: 'rater_assessments', menuTitle: '360 Assessments', headerTitle: '360 Assessments', icon: 'pe-7s-note2', class: 'titleMenu' }
    ]
    // [
    //     { path: 'coach_directory', menuTitle: 'Coach Directory', headerTitle: 'Coach Directory', icon: 'pe-7s-notebook', class: '' },
    //         //{ path: 'help',menuTitle: 'Help', icon: 'pe-7s-help1', class: 'borderTop' },
    // ],
    //[
    //    { path: 'raters', menuTitle: 'Raters', headerTitle: 'Raters', icon: 'pe-7s-users', class: '' },
    //]
];

export const RATERS_ROUTES: any[] = [
    //[
    //    { path: 'rater_assessments', menuTitle: 'Assessments', headerTitle: 'Assessments', icon: 'pe-7s-note2', class: '' },
    //]
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
    administratorMenuItems: any[];
    coachesMenuItems: any[];
    clientsMenuItems: any[];
    raterMenuItems: any[];
    mode: string = ""
    location: Location;
    routeActive: string = "";

    public get isBetaEnvironment(): boolean {
        return this.myGlobals.getEnvironment() === EnvironmentEnum.Beta;
    }

    constructor(
        public myGlobals: Globals,
        location: Location
    ) {
        this.location = location;
    }

  ngOnInit() {
      this.administratorMenuItems = ADMIN_ROUTES.filter(menuItem => menuItem);
      this.coachesMenuItems = COACHES_ROUTES.filter(coacheMenuItem => coacheMenuItem);
      this.clientsMenuItems = CLIENTS_ROUTES.filter(clientMenuItem => clientMenuItem);
      this.raterMenuItems = RATERS_ROUTES.filter(raterMenuItem => raterMenuItem);

      this.setActiveRoute();
    }
    
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true; 
    }

    setActiveRoute() {
        var title = this.location.path();
        title = this.location.prepareExternalUrl(this.location.path());
        let result = title.split('/');
        this.routeActive = result[2];
        console.log('TITLE', this.routeActive);
    }

    ngAfterContentInit() {
        this.setActiveRoute();
    }

    closeSidebarMenu(event: any) {
        console.log(event);

        if (event.target.className !== "material-icons closeMenu" && event.target.className !== "leftMenu-backdrop" ) {
            $('.nav.responsive-nav li').removeClass('active');
            event.target.parentElement.parentNode.classList.add("active");
            event.target.parentNode.classList.add("active");
        }


        if ($(window).width() < 991) {
            console.log('closeSidebarMenu');

            if (!this.myGlobals.toggleMenuWithOutLoggin) {
                this.myGlobals.toggleButton.classList.add('toggled');
                setTimeout(() => {
                    //icon animation
                    this.myGlobals.toggleButton.classList.remove('toggled');

                }, 10);
            }
            
            this.myGlobals.sidebarVisible = false;
            $('body').removeClass('nav-open');
            $('.main-panel').css('margin-left', 0);
            $('.leftMenu-backdrop').css('right', '-100%');
        }


    }

    showMenuItemByUserType(itemName: string) {
        //creo una funcion que se encargue de validar si se puede ver o no el item del menu                     //DONE
        //recibiendo el nombre del campo como parametro en la funcion                                           //DONE 
        //ahi valido si existe en un arreglo que contenga los nombres de los campos que puede ver el manager    //DONE
        //y si es asi entonces retorno un true o un false                                                       //DONE
        if (itemName == 'notdefinied') return false;

        if (this.myGlobals.getUserType() == "manager") {
            //console.log(itemName);
            return this.myGlobals.managerAvailableRoutes.includes(itemName);
        } else {
            return true;
        }

    }

    getSupport() {
        console.log("Get support");
        $('#supportModal').modal('show');
    }
}
